import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject ,  Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../../../app.constants';
import { IonicAngular4CacheService } from 'ionic-angular4-cache';

@Injectable()
export class AssociateService {

    constructor(
        private router: Router,
        private _http: HttpClient,
        private config: Configuration,
        public ionicAngular4Cache: IonicAngular4CacheService
    ) { }

    public uploadFile(file: any) {
        if (file) {
            return this._http.post(`${this.config.ServerApiUrl}/associate/uploadFile`, { 'file': file })
        }
    }

    public getAllAssociatesFilter(regex: string, initial?: string , role?: string) {
            return this._http.get(`${this.config.ServerApiUrl}/associate/readAllReg?reg=${regex}&&initial=${initial}&&role=${role}`);
    }

    public getAllAssociates(skip, limit) {
        return this._http.get(`${this.config.ServerApiUrl}/associate/readAll/${skip * limit}/${limit}`);
    }

    public getAssociateCount() {
        return this._http.get(`${this.config.ServerApiUrl}/associate/count`);
    }

    public getAssociate(id?: String) {
        if (id) {
            return this._http.get(`${this.config.ServerApiUrl}/associate/read?id=${id}`);
        } else {
            return this._http.get(`${this.config.ServerApiUrl}/associate/read?id`);
        }
    }

    public createAssociate(associate: any) {
        if (associate != null) {
            return this._http.post(`${this.config.ServerApiUrl}/associate/create`, associate);
        }
    }


    public search(skip, limit, query, sort) {
        return new Promise((ok, notOk) => {
            const queryData = { 'query': query, 'sort': sort };
            const searchObservable = this._http.post(`${this.config.ServerApiUrl}/associate/search/${skip * limit}/${limit}`, queryData);
            searchObservable.subscribe(data => {
                this.ionicAngular4Cache.saveItemOld(`associateSearch`, data);
                ok(data);
            });
        });
    }

    public powerSearch(skip, limit, query, sort) {
        return new Promise((ok, notOk) => {
            const queryData = { 'query': query, 'sort': sort };
            const searchObservable = this._http.post(`${this.config.ServerApiUrl}/associate/powersearch/${skip * limit}/${limit}`, queryData);
            searchObservable.subscribe(data => {
                this.ionicAngular4Cache.saveItemOld(`associateSearch`, data);
                ok(data);
            });
        });
    }

    public markAsInactive(id: String,archiveOrInactive: String) {
        if (id != null) {
            return this._http.post(`${this.config.ServerApiUrl}/associate/delete`, { 'idToDelete': id,'archiveOrInactive': archiveOrInactive });
        }
    }

    public getAssociatesStats() {
        return this._http.get(`${this.config.ServerApiUrl}/associate/basicStats`);
    }

    public updateAssociate(associate: any) {
        return this._http.put(`${this.config.ServerApiUrl}/associate/update`, associate);
    }
    public updateAssociateWorkingGroup(associate: any) {
        return this._http.put(`${this.config.ServerApiUrl}/associate/workingGroupUpdate`, associate);
    }

    public getNewAssociate() {
        return this._http.get(`${this.config.ServerApiUrl}/associate/getNewAssociate`);
    }

    public getAssociateChartData(queryType, query) {
        return this._http.post(`${this.config.ServerApiUrl}/associate/${queryType}`, query);
    }

    public bulkArchive(associates, archiveCredentials, query?) {
        if (query) {
            return this._http.post(`${this.config.ServerApiUrl}/associate/bulkArchive`,  { 'idsToDelete': associates, 'query': query,
            'lastArchivedBy': archiveCredentials});
        } else {
            return this._http.post(`${this.config.ServerApiUrl}/associate/bulkArchive`,  { 'idsToDelete': associates,
            'lastArchivedBy': archiveCredentials});
        }
    }

    public bulkReminderEmail(associates, query?) {
        if (query) {
            return this._http.post(`${this.config.ServerApiUrl}/associate/bulkEmail`,  { 'idsToSendEmail': associates, 'query': query});
        } else {
            return this._http.post(`${this.config.ServerApiUrl}/associate/bulkEmail`,  { 'idsToSendEmail': associates});
        }
    }

    public transferAssociate(prevOrg, newOrg, associateObj) {
        return this._http.post(`${this.config.ServerApiUrl}/associate/transfer`,  { 'previousOrganization': prevOrg,
        'newOrganization': newOrg, 'associate': associateObj });
    }

    public unarchiveAssociate( associateObj) {
        return this._http.post(`${this.config.ServerApiUrl}/associate/unarchive`,  { 'associate': associateObj });
    }

    public reactivateAssociate( associateObj) {
        return this._http.post(`${this.config.ServerApiUrl}/associate/reactivate`,  { 'associate': associateObj });
    }
    public removeFromWorkgroup(groupId, associate) {
        this._http.post(`${this.config.ServerApiUrl}/WorkingGroup/read`,{ids:groupId}).subscribe(res => {
            const group = JSON.parse(JSON.stringify(res[0]));
            group.Members = group.Members.filter(member => {
                if ( member.associateId !== associate._id) {
                    return member;
                }
            })
            this._http.put(`${this.config.ServerApiUrl}/WorkingGroup/update`,group).subscribe(res => {});
        },error => {
            console.log(error)
        })
    }

    public revokeLoginAccess(userids) {
        // tslint:disable-next-line:max-line-length
        return this._http.post(`${this.config.ServerApiUrl}/associate/revokeLoginAccess`, {userIds: Object.assign([], userids)});
    }

    public giveLoginAccess(userIds) {
        // tslint:disable-next-line:max-line-length
        return this._http.post(`${this.config.ServerApiUrl}/associate/giveLoginAccess`, {userIds: userIds});
    }

    public getDistinctAssociateCountries() {
        return this._http.get(`${this.config.ServerApiUrl}/associate/getAssociateCountries`);
    }

    public getLastValidatedCard(associateId, cardName) {
        return this._http.post(`${this.config.ServerApiUrl}/associate/validatedCard`, {associateId: associateId, cardName: cardName});
    }

    public scheduleTransferTask (cronJobTask) {
        return this._http.post(`${this.config.ServerApiUrl}/associate/scheduleTransferTask`,
        {'scheduledTransfer': cronJobTask});
    }

    public managementTabInfo (associateId) {
        return this._http.get(`${this.config.ServerApiUrl}/associate/getReportinLine?id=${associateId}`);
    }

    public associateDeparture (associateObject, transferHistory) {
        return this._http.post(`${this.config.ServerApiUrl}/associate/departure`, {associate: associateObject, 
            transferHistory: transferHistory});
    }

    public associateTransfer(associateObject, transferHistoryObject, transferType, prevOrgId, newOrgId) {
        return this._http.post(`${this.config.ServerApiUrl}/associate/transferBetweenLeganEntitiesAndCompanies`,
         // tslint:disable-next-line:max-line-length
         {associate: associateObject, transferHistory: transferHistoryObject , transferType: transferType, previousOrganizationId: prevOrgId, newOrganizationId: newOrgId });
    }

    public associateTransferHistoryUpdate(associateObject) {
        return this._http.put(`${this.config.ServerApiUrl}/associate/update`, associateObject);
    }

    public transferHistorSearch(skip, limit, query, sort) {
        const queryData = { 'query': query, 'sort': sort };
        // tslint:disable-next-line:max-line-length
        return this._http.post(`${this.config.ServerApiUrl}/associate/transferHistory/${skip * limit}/${limit}`, queryData);
    }

    public pendingTransferSearch(skip, limit, query, sort) {
        const queryData = { 'query': query, 'sort': sort };
        // tslint:disable-next-line:max-line-length
        return this._http.post(`${this.config.ServerApiUrl}/associate/transferPending/${skip * limit}/${limit}`, queryData);
    }

    public getTransferHistory(id) {
        const queryData = { 'id': id };
        // tslint:disable-next-line:max-line-length
        return this._http.post(`${this.config.ServerApiUrl}/associate/getHistoryTransfer`, queryData);
    }

    public getPendingTransfer(id) {
        const queryData = { 'id': id };
        // tslint:disable-next-line:max-line-length
        return this._http.post(`${this.config.ServerApiUrl}/associate/getPendingTransfer`, queryData);
    }

    public exportVcard(asscObj) {
        // tslint:disable-next-line:max-line-length
        return this._http.post(`${this.config.ServerApiUrl}/associate/exportVcard`, asscObj);
    }

    public checkAssociatInPendingTransfers(associateID) {
        // tslint:disable-next-line:max-line-length
        return this._http.post(`${this.config.ServerApiUrl}/associate/pendingTransferUniqueCheck`,{ associateId: associateID});
    }

    public pendingTransferEdit(cronJobTask) {
        // tslint:disable-next-line:max-line-length
        return this._http.post(`${this.config.ServerApiUrl}/associate/editPendingTransfer`, { cronJob: cronJobTask});
    }

    public deletependingTransfer(cronJobTaskId) {
        // tslint:disable-next-line:max-line-length
        return this._http.post(`${this.config.ServerApiUrl}/associate/deletePendingTransfer`, { id: cronJobTaskId});
    }

    public getAssociateBySiteId(siteId) {
        // tslint:disable-next-line:max-line-length
        return this._http.post(`${this.config.ServerApiUrl}/associate/getAssociateBySiteId`, { siteId: siteId});
    }


    public getUserIdsAndEmails(query) {
        // tslint:disable-next-line:max-line-length
        return this._http.post(`${this.config.ServerApiUrl}/associate/getUsersIdsAndEmails`,query);
    }

    public getManagementHeirarchyGraphical(query) {
        console.log('getGraphicalManagementQuery', query);
        // tslint:disable-next-line:max-line-length
        return this._http.post(`${this.config.ServerApiUrl}/associate/getManagementHeirarchyGraphical`,query);
    }
}
